import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../global/globals';

@Injectable({ providedIn: 'root' })
export class EspService {
  private baseUrl = this.globals.backendUri + '/esp';
  constructor(private http: HttpClient, private globals: Globals) {}

  getManifest(type: string, moduleTypeCode: string, chipTypeCode: string, displayTypeCode: string) {
    return this.http.get<any>(`${this.baseUrl}/manifest?type=${type}&module-type=${moduleTypeCode}&chip-type=${chipTypeCode}&display-type=${displayTypeCode}`);
  }
}
